import React from "react";

/** "Use HTTPS": a small checkbox beside a web control. */
export const UseHttpsCheckbox = ({
  checked,
  onChange,
  testId,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  testId: string;
}) => (
  <label className="flex items-center gap-1 font-mulish text-[13px] text-[#4c5257] cursor-pointer">
    <input
      type="checkbox"
      checked={checked}
      onChange={(event) => {
        const next = event.target.checked;
        onChange(next);
      }}
      data-testid={testId}
    />
    Use HTTPS
  </label>
);
